module.exports = __webpack_public_path__ + "img/wancheng.3e19050d.png";